import { ApiClient } from '../api-client';

const BackerApi = ApiClient.service.backer;
/**
 *  useBackerApi is a hook that returns a reusable axios instance with auth
 * @returns {AxiosInstance}
 */
const useBackerApi = () => {
  return BackerApi;
};

export { BackerApi, useBackerApi };
